import {Component, inject, OnInit} from '@angular/core';
import {PatientManagementService} from '../../patient-management.service';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {PatientFormFactory} from '../../factories/patient-form.factory';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import {Sex} from '../../../../core/enums/sex.enum';
import {Language} from '../../../../core/enums/language.enum';
import {CountryGroup, CountryService} from '../../../../core/services/country.service';
import {PatientMapper} from '../../mappers/patient.mapper';
import {PatientModel} from '../../models/patient.model';
import {PatientDto} from '../../dtos/patient.dto';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {DateMaskDirective} from '../../../../shared/directives/date-mask.directive';
import {PhoneInput} from '../../../../shared/components/phone-input/phone-input.component';
import {HttpErrorResponse} from '@angular/common/http';
import {ErrorService} from '../../../../core/services/error.service';

@Component({
  selector: 'app-patient',
  imports: [
    TranslocoPipe,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSelectModule,
    TextButton,
    DateMaskDirective,
    PhoneInput
  ],
  templateUrl: './patient.component.html',
  styleUrl: './patient.component.scss'
})
export class PatientComponent implements OnInit {
  patientManagementService = inject(PatientManagementService);
  fb = inject(FormBuilder);
  errorService = inject(ErrorService);
  translocoService = inject(TranslocoService);
  countryService = inject(CountryService);

  patientForm!: FormGroup;

  get sexes(): Sex[] {
    return Object.values(Sex)
  }

  get languages(): Language[] {
    return Object.values(Language)
  }

  get countryGroups(): CountryGroup[] {
    return this.countryService.countryGroups;
  }

  get phoneRequired() {
    return this.patientForm.hasError("phoneRequired") && (this.patientForm.get('phone')?.touched || this.patientForm.get('mobile')?.touched);
  }

  ngOnInit() {
    if (!this.patientManagementService.patientDto) {
      return;
    }

    const patientModel: PatientModel = PatientMapper.toPatientModel(this.patientManagementService.patientDto);
    patientModel.countryCode = this.countryService.offeredCountryCodeOf(patientModel.countryCode);
    this.patientForm = PatientFormFactory.createPatientForm(this.fb, patientModel);
  }

  save() {
    this.patientForm.markAllAsTouched();
    if (this.patientForm.invalid) {
      return;
    }

    const patientDto: PatientDto = PatientMapper.toPatientDto(this.patientForm.value);
    this.patientManagementService.updatePatient(patientDto).subscribe({
      next: (patientDto: PatientDto) => {
        this.patientManagementService.patientDto = patientDto;
      },
      error: (error: HttpErrorResponse) => {
        this.errorService.handleError(error, this.translocoService.translate('error.title.editPatient'));
      }
    });
  }
}
